import { atom } from 'recoil'

const key = '@app/unread-message-count'

const unreadMessageCountAtom = atom<number>({
  key,
  default: 0,
})

export { unreadMessageCountAtom }
